export default __webpack_public_path__ + "images/US.1e63949.png";